// extracted by mini-css-extract-plugin
export var contestImage = "PickemsImage-module--contestImage--730da";
export var svgIcon = "PickemsImage-module--svgIcon--0c36e";